/**
 * bundle-color-attribute.js
 * Farben Willenborg, 2026-08-24
 *
 * PROBLEM
 * Bei einem nativen Shopify-Bundle (Komplettset) legt der Kunde das Elternprodukt
 * in den Warenkorb. Die Line-Item-Property "Farbauswahl" haengt an dieser Elternzeile.
 * Beim Anlegen der Bestellung klappt Shopify das Set in seine Komponenten auf und
 * kopiert die Property NICHT auf die Komponentenzeilen, sondern parkt sie auf dem
 * Elternobjekt (LineItemGroup.customAttributes). Die Bestellseite im Admin rendert
 * nur Properties pro Zeile, deshalb sieht das Buero bei einem Set ausschliesslich
 * die Stufe ("Wunschfarbton hell") und nie den konkreten Ton.
 * Belegt an Bestellung #10411 vom 22.08.2026.
 *
 * LOESUNG
 * Denselben Wert zusaetzlich als Cart-Attribut schreiben. Cart-Attribute werden zu
 * order.customAttributes und erscheinen im Admin auf der Bestellung unter
 * "Weitere Details". Der Wert wird bei jeder Warenkorbaenderung komplett neu aus dem
 * Warenkorb aufgebaut, damit Entfernen, Mengenaenderung und mehrere Sets im selben
 * Warenkorb sauber abgebildet sind.
 *
 * NICHT betroffen sind Einzelprodukte: dort haengt die Property an der Bestellzeile
 * selbst und wird im Admin ganz normal angezeigt. Deshalb greift dieses Skript
 * ausschliesslich bei Zeilen mit has_components === true.
 *
 * Das Skript schreibt nur Cart-Attribute. Es blockiert nichts, es aendert keine
 * Position, keinen Preis und keinen Checkout-Ablauf.
 */
(function () {
  'use strict';

  var PREFIX = 'Wunschfarbton';
  var PROPERTY = 'Farbauswahl';
  var DEBOUNCE_MS = 120;

  var busy = false;
  var pending = false;
  var timer = null;

  function hasCartCookie() {
    try {
      return document.cookie.indexOf('cart=') !== -1;
    } catch (e) {
      return true;
    }
  }

  /* "Farbenset fuer Rauputz und Klinker Fassaden - Silikonharzfarbe inkl. Grundierung"
     wird zu "Farbenset fuer Rauputz und Klinker Fassaden". */
  function shortTitle(title) {
    var t = String(title || 'Set').split(' - ')[0].trim();
    if (t.length > 60) t = t.slice(0, 57).trim() + '...';
    return t;
  }

  function desiredAttributes(cart) {
    var out = {};
    var seen = {};
    var items = (cart && cart.items) || [];

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.has_components !== true) continue;

      var props = item.properties || {};
      var color = props[PROPERTY];
      if (!color || !String(color).trim()) continue;

      var base = PREFIX + ' (' + shortTitle(item.product_title) + ')';
      seen[base] = (seen[base] || 0) + 1;
      var key = seen[base] === 1 ? base : base + ' #' + seen[base];
      out[key] = String(color).trim();
    }
    return out;
  }

  /* Nur die Differenz schicken. Ein leerer Wert loescht ein Attribut. */
  function diff(desired, current) {
    var update = {};
    var k;

    for (k in desired) {
      if (!Object.prototype.hasOwnProperty.call(desired, k)) continue;
      if (current[k] !== desired[k]) update[k] = desired[k];
    }
    for (k in current) {
      if (!Object.prototype.hasOwnProperty.call(current, k)) continue;
      if (k.indexOf(PREFIX) !== 0) continue;
      if (!Object.prototype.hasOwnProperty.call(desired, k)) update[k] = '';
    }
    return update;
  }

  function sync() {
    /* Laeuft schon eine Runde, wird direkt danach eine weitere angestossen,
       damit eine Aenderung waehrend des Abgleichs nicht verloren geht. */
    if (busy) {
      pending = true;
      return;
    }
    busy = true;

    fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart) return null;

        var update = diff(desiredAttributes(cart), cart.attributes || {});
        if (!Object.keys(update).length) return null;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: update }),
        });
      })
      .catch(function () {
        /* Stillschweigend aufgeben. Schlimmster Fall ist der Zustand von vorher. */
      })
      .then(function () {
        busy = false;
        if (pending) {
          pending = false;
          schedule();
        }
      });
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(sync, DEBOUNCE_MS);
  }

  function isCartMutation(url) {
    if (!url) return false;
    var u = String(url);
    return (
      u.indexOf('/cart/add') !== -1 ||
      u.indexOf('/cart/change') !== -1 ||
      u.indexOf('/cart/update') !== -1 ||
      u.indexOf('/cart/clear') !== -1
    );
  }

  /* Empire legt ueber fetch in den Warenkorb (cart-drawer.js), die Produktseite
     laeuft ueber jquery.cart.js und damit ueber XHR. Beide Wege abfangen, ohne
     das Verhalten der urspruenglichen Aufrufe zu veraendern. */
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var promise = originalFetch.apply(this, arguments);
      try {
        var first = arguments[0];
        var url = typeof first === 'string' ? first : first && first.url;
        if (!busy && isCartMutation(url)) {
          promise.then(schedule, function () {});
        }
      } catch (e) {
        /* Aufruf niemals stoeren. */
      }
      return promise;
    };
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__wbUrl = url;
      } catch (e) {
        /* egal */
      }
      return originalOpen.apply(this, arguments);
    };

    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      try {
        if (!busy && isCartMutation(this.__wbUrl)) {
          this.addEventListener('loadend', schedule);
        }
      } catch (e) {
        /* Aufruf niemals stoeren. */
      }
      return originalSend.apply(this, arguments);
    };
  }

  /* Sicherheitsnetz: einmal pro Seitenaufruf nachziehen, falls eine Aenderung
     unterwegs verloren ging. Bei leerem Warenkorb gibt es kein cart-Cookie,
     dann sparen wir uns den Aufruf. */
  function initialSync() {
    if (hasCartCookie()) schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) initialSync();
  });
})();
